import styles from './Gradient.module.css';

export default function Gradient() {
	return <div className={styles.divBackground} />;
}
